import React from 'react';
import { Typography } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
const ButtonLinkPreviewFAI = ({ custom_requirements }) => {
    const checkAdditionalRequirements = () => {
        const requirements = custom_requirements;
        if (!Array.isArray(requirements))
            return false;
        return requirements.some(req => {
            const label = req?.label?.toLowerCase().trim();
            return label === 'first article inspection' || label == 'first article inspection (standard)';
        });
    };
    const popup = (url) => {
        window.open(url, '_blank', 'width=800,height=800,left=200,top=200');
    };
    return checkAdditionalRequirements() ? (React.createElement(Typography.Link, { style: {
            marginTop: 1,
            display: 'flex',
            alignItems: 'center',
            color: '#D92923',
            gap: 6,
        }, onClick: () => popup('https://partsbadger-static-files.s3.us-east-2.amazonaws.com/static/files/fai_certificate.pdf') },
        React.createElement(EyeOutlined, null),
        React.createElement("span", null, "Preview FAI Certificate"))) : null;
};
export default ButtonLinkPreviewFAI;
